import { useContext } from 'react'

import { ParametrizationRevisionContext } from '@provider/Parametrization/RevisionProvider'

import type { IParametrizationRevisionContext } from '@base/@types/providers/Parametrization/RevisionProvider'

export default function useParametrizationRevision(): IParametrizationRevisionContext {
  const context = useContext(ParametrizationRevisionContext)

  return context
}
